import React, { useState } from 'react';
import { AlertBlock } from '../AlertBlock';
import { getActiveMessages } from '../../services/systemMessages';

export function SystemMessageBanner() {
  const messages = getActiveMessages();
  // Session-only: dismissals should reappear on reload, not persist.
  const [dismissedIds, setDismissedIds] = useState<Set<string>>(new Set());

  const visible = messages.filter((m) => !dismissedIds.has(m.id));
  if (visible.length === 0) return null;

  const dismiss = (id: string) => setDismissedIds((prev) => new Set(prev).add(id));

  return (
    <>
      {visible.map((message) => (
        <AlertBlock
          key={message.id}
          type={message.type}
          heading={message.title}
          onDismiss={() => dismiss(message.id)}
        >
          {message.content}
        </AlertBlock>
      ))}
    </>
  );
}
